import { DetailedPriceListColumns } from "../components/columns/detailed-price-columns";
import { NavigationPath } from "./../../../config/routing/NavigationPath";

export const generateColumns = (pathname: string) => {
  if (pathname === NavigationPath.DETAILED_PRICE_LIST) {
    return DetailedPriceListColumns;
  }
};